import { createContext } from "react";
import { useContext } from "react";
import { getColorSet } from "~/modules/colors";

export const ThemeContext = createContext();
ThemeContext.displayName = "ThemeContext";

export const getThemeForModule = moduleTheme => {
    const themeCtx = useContext(ThemeContext);

    if (moduleTheme && moduleTheme !== "inherit")
        return getColorSet(moduleTheme);

    return themeCtx || getColorSet("sky");
};
